import React from 'react'

import {
    SecurityListTableContainer, 
} from '../security.style'
import {
    TableHead,
    TableBodyRow
} from '../../../../../widget/styledComponents/table.style'

import { Dialog, IconButton, Pagination, Pane, Spinner, TrashIcon, toaster } from 'evergreen-ui'
import Cookies from 'js-cookie';
import { gql, useMutation,useQuery } from '@apollo/client';
import AddAssetsPlaceholder from '../../../../../widget/add_assets_placeholder';



export const FETCH_SECURITY = gql`
query Securities_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  securities_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    name
    email
    facility
    isActive
  }
}

`;


function SecurityListTable() {
const facilityId = Cookies.get('facilityId');

const { loading, data }  = useQuery(FETCH_SECURITY,{
variables: {
    facilityId:facilityId,
    pagination: {
        "cursor": null,
        "limit": 30
    },
 },
});
  return (
    <div>

    <SecurityListTableContainer>
            {/* {facilityId} */}
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>Name</TableHead>
                    <TableHead>Email</TableHead>
                    <TableHead>Facility</TableHead>
                    <TableHead>Action</TableHead>
                </tr>
                </thead>

                <tbody>
                    {loading && <Spinner/> }
                    {data &&
                    
                    data.securities_getByFacility.map((user) => 
                        <TableBodyRow 
                            
                        >
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.facility}</td>
                            <td>
                                <DeleteSecurityBtn id={user.id} />
                            </td>
                        </TableBodyRow>
                        )
                    }
                </tbody>
            </table>
            <center>
              <AddAssetsPlaceholder/>
            </center>
            <Pagination className='transparent z-depth-0' page={1} totalPages={5}></Pagination>
        </SecurityListTableContainer>  
    </div>
  )
}

export default SecurityListTable





export const DELETE_SECURITY = gql`
mutation Owner_delete($ownerDeleteId: ID!) {
  owner_delete(id: $ownerDeleteId) {
    code
    success
    error
  }
}
`;
function DeleteSecurityBtn(props) {
    
    const accesTokenValue = Cookies.get('userAccessToken');
    const [deleteSecurity, { loading }] = useMutation(DELETE_SECURITY);
    const [isShown, setIsShown] = React.useState(false)

    const id= props.id;

    const handleSubmit=()=>{
        deleteSecurity({
          variables: { 
            ownerDeleteId:id,
          },
          context: {
            headers: {
              Authorization: `Bearer ${accesTokenValue}`,
            },
          },
        })
        .then((response) => {
          toaster.success("Owner added successfully.")
          window.location.reload()
        })
        .catch((error) => {
        console.log("sded",error)
          toaster.danger(error.message)
        });
      }
  
    

        return (
          <Pane>

            <Dialog
                isShown={isShown}
                title="Delete Owner"
                intent="danger"
                onCloseComplete={() => setIsShown(false)}
                confirmLabel="Delete"
                isConfirmLoading={loading}
                shouldCloseOnEscapePress={false}
                shouldCloseOnOverlayClick={false}
                onConfirm={()=>handleSubmit()}
            >
                Are you sure you want to delete this owner?
            </Dialog>
            
            <IconButton
            onClick={() => setIsShown(true)}
            icon={TrashIcon} intent="danger"  />
          </Pane>
        )
}